/**
 * 三包登记的 表单验证规则
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                work_time: [{ required: true, trigger: 'blur' }],
                'customer.customer_name' : [{ required: true, trigger: 'blur' }],
                'customer.customer_account': [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                'business_team_id': [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                'invoice_unit_name' : [{ required: true, trigger: 'blur' }],
                'nsnumnber' : [{ required: true, trigger: 'blur' }],
                'invoice.invoice_unit_name' : [{ required: true, trigger: 'blur' }],
                // 'invoice.taxpayer_mark' : [{ required: true, trigger: 'blur' }]
            }
        }
    },
    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         */
        validateProduct (arr) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                // let bool = false
                // 判断是否选择货品
                if (!row.product || !row.product.product_id) {
                    msg += '"货品"'
                }
                // 是否填写了胎号
                if (!row.taihao || !row.taihao.taihao_no) {
                    msg += '"胎号"'
                }
                // 是否填写了病象
                if (!row.symptom || !row.symptom.bingxiang_id) {
                    msg += '"病象"'
                }
                // 余花 2017-11-09 邮件通知 改为非必填
                // if (!row.yuhua) {
                //     msg += '"余花"'
                // }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            } else {
                msg = this.validatorTaihao(arr)
            }
            return msg
        },
        /**
         * 胎号重复的判定
         * @return {[type]} [description]
         */
        validatorTaihao (arr) {
            let msg = ''
            let diffArr = [] // 不同胎号的存储
            for (let i in arr) {
                let row = arr[i]
                if (row.taihao) {
                    let no = String(row.taihao.taihao_no).replace(/(^\s*)|(\s*$)/g,"")
                    // 对比diff中的值
                    for (let j in diffArr) {
                        if (no === diffArr[j]) {
                            msg = '第' + parseInt(parseInt(i) + 1) + '行 与 第' + parseInt(parseInt(j) + 1) + '行 的胎号重复'
                            break;
                        }
                    }
                    diffArr.push(no)
                }
            }
            // 2017-11-02 这里修改成，重复胎号只给提示，仍然可以提交（这个是罗老师给子薇说的）
            if (msg.length > 0) {
                this.$notify({
                    title: '胎号提示',
                    message: msg,
                    type: 'warning'
                })
            }
            return ''
        }
    }
}